import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import aiIntegrationsAPI from '../../api/aiIntegrations';

export const types = {
  SET_UI_FLAG: 'SET_AI_INTEGRATIONS_UI_FLAG',
  SET_RECORDS: 'SET_AI_INTEGRATIONS',
  ADD_RECORD: 'ADD_AI_INTEGRATION',
  UPDATE_RECORD: 'UPDATE_AI_INTEGRATION',
  DELETE_RECORD: 'DELETE_AI_INTEGRATION',
  SET_TEST_RESULT: 'SET_AI_INTEGRATION_TEST_RESULT',
};

const state = {
  records: [],
  uiFlags: {
    fetchingList: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
    testingItem: false,
  },
  lastTestResult: null,
};

export const getters = {
  getAiIntegrations: _state => _state.records.slice().sort((a, b) => a.id - b.id),
  getUIFlags: _state => _state.uiFlags,
  getLastTestResult: _state => _state.lastTestResult,
};

export const actions = {
  async get({ commit }) {
    commit(types.SET_UI_FLAG, { fetchingList: true });
    try {
      const { data } = await aiIntegrationsAPI.get();
      commit(types.SET_RECORDS, data.data || []);
    } finally {
      commit(types.SET_UI_FLAG, { fetchingList: false });
    }
  },

  async create({ commit }, payload) {
    commit(types.SET_UI_FLAG, { creatingItem: true });
    try {
      const { data } = await aiIntegrationsAPI.create({ ai_integration: payload });
      commit(types.ADD_RECORD, data);
      return data;
    } finally {
      commit(types.SET_UI_FLAG, { creatingItem: false });
    }
  },

  async update({ commit }, { id, ...payload }) {
    commit(types.SET_UI_FLAG, { updatingItem: true });
    try {
      const { data } = await aiIntegrationsAPI.update(id, { ai_integration: payload });
      commit(types.UPDATE_RECORD, data);
      return data;
    } finally {
      commit(types.SET_UI_FLAG, { updatingItem: false });
    }
  },

  async delete({ commit }, id) {
    commit(types.SET_UI_FLAG, { deletingItem: true });
    try {
      await aiIntegrationsAPI.delete(id);
      commit(types.DELETE_RECORD, id);
    } finally {
      commit(types.SET_UI_FLAG, { deletingItem: false });
    }
  },

  async test({ commit }, id) {
    commit(types.SET_UI_FLAG, { testingItem: true });
    try {
      const { data } = await aiIntegrationsAPI.test(id);
      commit(types.SET_TEST_RESULT, { id, ...data });
      return data;
    } catch (error) {
      const payload = error.response?.data || { ok: false, error: error.message };
      commit(types.SET_TEST_RESULT, { id, ...payload });
      throw error;
    } finally {
      commit(types.SET_UI_FLAG, { testingItem: false });
    }
  },

  async regenerateSecret({ commit }, id) {
    const { data } = await aiIntegrationsAPI.regenerateSecret(id);
    commit(types.UPDATE_RECORD, data);
    return data;
  },
};

export const mutations = {
  [types.SET_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_RECORDS]: MutationHelpers.set,
  [types.ADD_RECORD]: MutationHelpers.create,
  [types.UPDATE_RECORD]: MutationHelpers.update,
  [types.DELETE_RECORD]: MutationHelpers.destroy,
  [types.SET_TEST_RESULT](_state, payload) {
    _state.lastTestResult = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
